import { Fragment, useEffect, useState } from "react"
import { favoriteActions } from "../../../../../store/favorite-slice"
import { faArrowDownAZ } from "@fortawesome/free-solid-svg-icons"
import useFilter from "../../../../../hook/useFilter"
import useVariable from "../../../../../hook/useVariable"
import Resort from "./resort"
import { useDispatch, useSelector } from "react-redux"
import Pagination from "./pagination"
import InfoIcon from "../../../../InfoIcon"

export default function Filter({children}){


    const [showFilter, setShowFilter] = useState(false)

    let defaultFavoriteCount = useSelector((state) => state.favorite.filterFavoriteCount)
    let pagination = useSelector((state) => state.favorite.pagination)
    let sliceFilters = useSelector(state => state.favorite.filter)
    let sliceActions = favoriteActions
    let sliceItems = useSelector(state => state.favorite.favorites)

     const { doFilter } = useFilter()
        const { variableValue } = useVariable()

        const [paginationItems, setPaginationItems] = useState([])

        let dispatch=useDispatch()

        const [isMount, setIsMount] = useState(false)



        useEffect(() => {
            let items = []
            if (pagination) {
                pagination.forEach((item, key) => {
    
                                       items.push(<Pagination key={key} favorites={item} index={key} />)
                })
            }
    
            setPaginationItems(items)
        }, [pagination])



            useEffect(() => {
        
                if (!isMount) {
                    setIsMount(true)
                    return
                }
        
        
                doFilter(sliceFilters, sliceItems, sliceActions)
            }, [sliceFilters])



    return <div className="p-3" >
       
        <div className="card shadow  bg-white rounded p-3 mb-3" style={{ cursor: 'pointer' }} onClick={() => {
            setShowFilter(!showFilter)
        }}  >

            <InfoIcon icon={faArrowDownAZ} size='xl' />

        </div>
        {showFilter &&
            <Fragment>
                <label>Pagination</label><select name="filterPostCount" defaultValue={sliceFilters.pagination} className="mb-2" onChange={(event) => {
                    let value = variableValue(event.target.value)
                    dispatch(favoriteActions.setFilter({
                        key: 'pagination',
                        value
                    }))

                }} >
                    <option value='' >All</option>

                    {
                        defaultFavoriteCount.map((item, key) => {

                            return <option key={key} value={item} >{item}</option>
                        })
                    }
                </select>

                <Resort type='ptitle' name='ProductTitle' />
                <Resort type='created_on' name='CreatedOn' />
                
            </Fragment>}
        <input type="text" name="filter-email-username" className="mb-2" defaultValue={sliceFilters.search} placeholder="order id or product title" onInput={(event) => {
            let value = variableValue(event.target.value)

            dispatch(favoriteActions.setFilter({
                key: 'search',
                value
            }))


        }} />

        {children}

        <div className="pagination-container">{paginationItems}</div>
       
    </div>
}
